// DHCP服务器
import React, { createRef, PureComponent } from 'react';
import { Button, notification, Form, InputNumber } from 'antd';
import { ServerPageDecoration } from './ServerPageDecoration'
import IPut from '../IPut';
import { BLANK_IP } from '../Device/Simulator/Ethernet';

export class DHCPServer extends PureComponent {
    constructor(props) {
      super(props);
  
      this.formRef = createRef();
  
      ['onReset', 'onSubmit', 'onFail', 'onChange'].forEach(func => this[func] = this[func].bind(this));
      
      const { device } = this.props;
      const ipConfig = device.getPortIPConfig();
  
      this.state = {
        version: 0,
        ipMode: ipConfig.ipMode,
      }
    }
  
    onReset() {
      this.formRef.current.resetFields();
      this.setState({
        version: 0
      });
    }
  
    async onSubmit(config) {
      const { device, onClose } = this.props;
      let { ipPoolRangeStart, ipPoolRangeEnd, ...ipconfig } = config;

      // 通过自身IP与子网掩码生成网段
      if((config.ipAddress === BLANK_IP) || (config.subnetMask === BLANK_IP)) {
        notification.error({
          message: 'IP层配置错误',
          description: 'IP地址或子网掩码不能为空'
        })
        return;
      }

      // IP是否已经存在
      if(config.ipAddress !== device.ipConfig.ipAddress) {
        const isIPExist = await (new Promise((resolve) => {
          // 验证IP是否冲突
          device.ICMP_ping(config.ipAddress, (response) => {
            resolve(response.result === 'success');
          });
        }));  

        if(isIPExist) {
          notification.error({
            message: '配置错误',
            description: 'IP地址配置与网络中设备冲突'
          });

          return;
        }  
      }
      
      if(ipPoolRangeStart >= ipPoolRangeEnd) {
          notification.error({
            message: '配置错误',
            description: `起始IP地址必须小于终止IP地址，保存失败！`
          });

          return;
      }

      device.updateIPConfig(ipconfig);
      device.updateDHCPPool(ipPoolRangeStart, ipPoolRangeEnd)

      this.setState({
        version: 0
      }, () => {
        notification.success({
            message: '配置已生效',
        });
    
        // 自动关闭
        onClose();
      });
    }
  
    onFail(errorInfo) {
      notification.error({
        message: '错误',
        description: '表单填写出错，请按照提示信息进行检查！'
      });
    }
  
    onChange(changedValues, allValues) {
      let { version } = this.state;
      version++;
  
      const nextState = {
        version
      };
  
      // 刷新UI
      if(changedValues.ipMode) {
        nextState.ipMode = changedValues.ipMode;
      }
  
      this.setState(nextState);
    }
  
    render() {
      const { formRef } = this;
      const { device } = this.props;
      const { ipConfig, ipPoolRangeStart, ipPoolRangeEnd } = device.toJSON();
      const { version } = this.state;
      const value = { ...ipConfig, ipPoolRangeStart, ipPoolRangeEnd };

      return (
        <ServerPageDecoration>
          <Form
            ref={formRef}
            name="IPConfig"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 10 }}
            initialValues={value}
            size="large"
            onFinish={this.onSubmit}
            onFinishFailed={this.onFail}
            onValuesChange={this.onChange}
          >
              <Form.Item
                  label="IP地址"
                  name="ipAddress"
                  rules={[{ required: true }]}
              >
              <IPut />
              </Form.Item>
              <Form.Item
                  label="子网掩码"
                  name="subnetMask"
                  rules={[{ required: true }]}
              >
                <IPut />
              </Form.Item>
              <Form.Item
                  label="起始IP"
                  name="ipPoolRangeStart"
                  rules={[{ required: true }]}
              >
                  <InputNumber min={1} max={255} step={1} precision={0} />
              </Form.Item>
              <Form.Item
                  label="终止IP"
                  name="ipPoolRangeEnd"
                  rules={[{ required: true }]}
              >
                  <InputNumber min={1} max={255} step={1} precision={0} />
              </Form.Item>
              <Form.Item
                  label="网关"
                  name="gateway"
                  rules={[{ required: true }]}
              >
                  <IPut />
              </Form.Item>
              <Form.Item
                  label="DNS服务器"
                  name="dns"
                  rules={[{ required: true }]}
              >
                  <IPut />
              </Form.Item>
              <Form.Item wrapperCol={{ offset: 4, span: 10 }}>
              <Button type={ version ? "danger": "primary"} htmlType="submit">
                确定
              </Button>
              <Button style={{marginLeft: 10}} htmlType="button" onClick={this.onReset}>
                  重置
              </Button>
              </Form.Item>
          </Form>
        </ServerPageDecoration>);
    }
}
